
// export const myGetter = ( state ) => {
//  return state
// }

export const stafferstypeList = state => state.stafferstype
export const stafferstypeSelectable = state => state.stafferstypeSelectable
export const stafferstypePaginatedData = state => state.stafferstypePaginatedData
export const staffertype = state => state.staffertype
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData